
import { useState } from 'react';
import { List, ListItem, ListItemText, Menu, MenuItem } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { Settings } from '@material-ui/icons';


let AdminMenu = () => {
    let [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    let handleOpen = (e: any) => {
        setAnchorEl(e.currentTarget);
    }

    let onClose = () => {
        setAnchorEl(null);
    }

    return (
        <>
            <List component="nav" disablePadding>
                <ListItem button onClick={(e) => handleOpen(e)}>
                    <ListItemText primary={<Settings />} />
                </ListItem>
            </List>

            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={anchorEl !== null}
                onClose={onClose}
            >
                <MenuItem component={RouterLink} to={'/admin/videndumusers'} onClick={onClose}>Users</MenuItem>
                <MenuItem component={RouterLink} to={'/admin/distributors'} onClick={onClose}>Distributors</MenuItem>
                <MenuItem component={RouterLink} to={'/admin/importrequests'} onClick={onClose}>Imports</MenuItem>
            </Menu>
        </>
    )
}

export default AdminMenu;